import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from '../../shared/base-service/base-api.service';
import { FleetVehicleSearchCriteria } from '../models/motor-carrier-account-fleet/fleet-vehicle-search-criteria';
import { MonthYearFirstRegisteredModel } from '../models/motor-carrier-account-fleet/month-year-first-registered.model';

@Injectable({
    providedIn: 'root'
})
export class MotorCarrierFleetVehicleService extends BaseApiService {

    constructor() {
        super();
    }

    /**
     * Gets the motor carrier fleet veicles
     * @param motorCarrierAccountFleetId The motor carrier account fleet id
     * @param pageNumber page number
     */
    public getMotorCarrierFleetVehicles(searchCriteria: FleetVehicleSearchCriteria): Observable<any> {
        // return this.get(`IRP/MotorCarrier/Fleet/${motorCarrierAccountNumberId}/Vehicles/PageNumber/${pageNumber}`);
        return this.post('IRP/MotorCarrier/Fleet/Vehicles/Paginated', searchCriteria);
    }

    /**
     *  Gets the MotorCarrier Fleet Vehicles without paginated
     * @param motorCarrierAccountNumberId
     * @param motorCarrierAccountFleetId
     */
    public getMotorCarrierAccountVehicleResults(motorCarrierAccountNumberId: number, motorCarrierAccountFleetId: Number): Observable<any> {
        return this.get(`IRP/MotorCarrier/Fleet/${motorCarrierAccountNumberId}/Vehicles/${motorCarrierAccountFleetId}`);
    }

    /**
     *  Gets the MotorCarrier Fleet Vehicles without paginated
     * @param motorCarrierAccountNumberId
     * @param motorCarrierAccountFleetId
     */
    public getMotorCarrierAccountVehicleResultsForDelete(motorCarrierAccountNumberId: number, motorCarrierAccountFleetId: Number): Observable<any> {
        return this.get(`IRP/MotorCarrier/Fleet/${motorCarrierAccountNumberId}/Vehicles/${motorCarrierAccountFleetId}/ForDelete`);
    }

    public getActiveVehicles(vehicleId: number) {
        return this.get(`TitleRegistration/Title/Vehicle/${vehicleId}/Active`);
    }

    public getVehicleOwnership(vehicleId: number) {
        return this.get(`IRP/MotorCarrier/Vehicle/${vehicleId}/Ownership`);
    }

    public getVehicleInformation(vehicleId: number) {
        return this.get(`Vehicle/Vehicle/${vehicleId}`);
    }

    public getPriceDigestOfVehicle(vin: any): Observable<any> {
        return this.get(`IRP/MotorCarrier/PriceDigest/${vin}`);
    }

    public isVehicleInActiveFleet(vehicleId: any): Observable<any> {
        return this.get(`IRP/MotorCarrier/Vehicle/ActiveFleet/${vehicleId}`);
    }

    /**
     * Search Fleet vehicles by Plate number ,VIN or Unit Number
     * @param motorCarrierAccountFleetId
     * @param searchItem
     * @param searchType
     */
    public getMotorCarrierAccountFleetVehicleDetails(motorCarrierAccountFleetId: Number, searchItem: string, searchType: Number): Observable<any> {
        return this.get(`IRP/MotorCarrier/Fleet/${motorCarrierAccountFleetId}/Vehicles/Search/${searchItem}/Type/${searchType}`);
    }

    public checkVehicleValidForAddVehicle(vehicleId: number, serviceTypeId: number) {
        return this.get(`IRP/MotorCarrier/Vehicle/${vehicleId}/ServiceType/${serviceTypeId}/Valid`);
    }

    public getFleetVehicleCreditStatus(vehicleId: number, motorCarrierAccountFleetId: number, registrationId: number) {
        return this.get(`IRP/MotorCarrier/Vehicle/${vehicleId}/Fleet/${motorCarrierAccountFleetId}/Registration/${registrationId}/CreditStatus`);
    }

    public getFleetVehicleRegistrations(vehicleId: number, motorCarrierAccountFleetId: number) {
        return this.get(`IRP/MotorCarrier/Vehicle/${vehicleId}/Fleet/${motorCarrierAccountFleetId}/Registrations`);
    }

    public getMotorCarrierAccountVehicleDetailsByVehicleId(vehicleId: number) {
        return this.get(`IRP/MotorCarrier/Vehicle/${vehicleId}/Details`);
    }

    public getMotorCarrierAccountVehicleTPA(tpaNumber: string, motorCarrierAccountFleetId: number) {
        return this.get(`IRP/MotorCarrier/Fleet/${motorCarrierAccountFleetId}/TPA/${tpaNumber}`);
    }

    public getMotorCarrierAccountVehicleTPAByVehicleId(vehicleId: number, motorCarrierAccountFleetId: number) {
        return this.get(`IRP/MotorCarrier/Fleet/${motorCarrierAccountFleetId}/TPA/Vehicle/${vehicleId}`);
    }

    public createTitleForVehicle(vehicleId: number) {
        return this.get(`IRP/MotorCarrier/Vehicle/${vehicleId}/Title`);
    }

    public validateMonthYearFirstRegistered(monthYearFirstRegisteredModel: MonthYearFirstRegisteredModel): Observable<any> {
        return this.post('IRP/MotorCarrier/Vehicle/FirstRegistered/Validate', monthYearFirstRegisteredModel);
    }

    public calculateMonthYearFirstRegistered(monthYearFirstRegisteredModel: MonthYearFirstRegisteredModel) {
        return this.post('IRP/MotorCarrier/Vehicle/FirstRegistered', monthYearFirstRegisteredModel);
    }

    public getMotorCarrierAccountVehicleFeeSummary(vehicleOwnershipId: number) {
        return this.get(`TitleRegistration/TitleRegistration/VehicleOwnership/${vehicleOwnershipId}/Fees`);
    }

    public getMotorCarrierAccountVehicleRegistrationHistory(data) {
        return this.post('IRP/MotorCarrier/RegistrationHistory', data);
    }

    public getMotorCarrierAccountTpaFeeSummary(permitNumber: string) {
        return this.get(`TitleRegistration/TitleRegistration/TPAFees/PermitNumber/${permitNumber}`);
    }

    public sendVehicleInquiry(vehicleId: number, businessTransactionNumberId: number, businessTransactionTypeId: number) {
        return this.get(`IRP/MotorCarrier/Vehicle/${vehicleId}/Transaction/${businessTransactionNumberId}/Type/${businessTransactionTypeId}/Inquiry`);
    }

    public getVehicleTRPData(ownershipCustomerRelationships: any, vehicleId: number) {
        return this.post(`IRP/MotorCarrier/Vehicle/${vehicleId}/TRP`, ownershipCustomerRelationships);
    }
}
